module.exports = __webpack_public_path__ + "img/google_signin.52a05e73.png";